/**
 * Lista das rotinas de treino do aluno (cada rotina pode ter N planos).
 * Cabeçalho tem "+ Nova Rotina" pra criar uma nova.
 *
 * Props:
 *   - studentId: usado no hook useWorkoutRoutines e no push da rota nova
 *
 * Estado interno: usa `useWorkoutRoutines(studentId)`.
 *
 * Decisões:
 *   - Mostra metadados resumidos (nº de planos + range de datas) pra
 *     UX clean. Detalhe completo fica na tela /routines/[id].
 */

import { memo } from 'react';
import { View, Text, TouchableOpacity, ActivityIndicator, StyleSheet } from 'react-native';
import { useRouter } from 'expo-router';
import { useWorkoutRoutines } from '@/hooks/useWorkoutRoutines';
import { sharedStyles } from './styles';

interface Props {
  studentId: string;
}

function RoutinesSectionImpl({ studentId }: Props) {
  const router = useRouter();
  const { routines, loading } = useWorkoutRoutines(studentId);

  return (
    <View style={sharedStyles.section}>
      <View style={sharedStyles.sectionRow}>
        <Text style={sharedStyles.sectionTitle}>Rotinas</Text>
        <TouchableOpacity onPress={() => router.push(`/(personal)/routines/new?studentId=${studentId}` as any)}>
          <Text style={sharedStyles.linkText}>+ Nova Rotina</Text>
        </TouchableOpacity>
      </View>
      {loading ? (
        <ActivityIndicator color="#C8102E" style={{ marginTop: 12 }} />
      ) : routines.length === 0 ? (
        <Text style={sharedStyles.empty}>Nenhuma rotina criada ainda.</Text>
      ) : (
        routines.map(r => (
          <TouchableOpacity
            key={r.id}
            style={styles.routineCard}
            onPress={() => router.push(`/(personal)/routines/${r.id}` as any)}
          >
            <Text style={styles.routineName}>{r.name}</Text>
            <Text style={styles.routineMeta}>
              {r.plans.length} treino{r.plans.length !== 1 ? 's' : ''}
              {r.start_date ? ` · ${r.start_date}` : ''}
              {r.end_date ? ` – ${r.end_date}` : ''}
            </Text>
          </TouchableOpacity>
        ))
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  routineCard: { backgroundColor: '#fff', padding: 14, borderRadius: 10, marginBottom: 8 },
  routineName: { fontSize: 15, fontWeight: '600', color: '#1A1A1A' },
  routineMeta: { fontSize: 12, color: '#888', marginTop: 3 },
});

export const RoutinesSection = memo(RoutinesSectionImpl);
